import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardsComponent} from './dashboards.component';

const routes: Routes = [
	{
		path: '',
		component: DashboardsComponent,
	},
];

@NgModule({
	imports: [
		RouterModule.forChild(routes),
	],
	exports: [
		RouterModule,
	],
})
export class DashboardsRoutingModule { }